import { supabase } from "@/lib/supabase";
import { useQuery } from "@tanstack/react-query";
import { useAuthContext } from "@/features/authentication/useAuthContext";

export function useRecipeTypeCounts() {
    const { user } = useAuthContext();
    return useQuery<Record<number, number>>({
        enabled: !!user,
        queryKey: ["recipeTypeCounts"],
        queryFn: async () => {
            const { data, error } = await supabase
                .from("recipes")
                .select("recipe_type_id")
                .eq("user_id", user!.id);

            if (error || !data) {
                console.error("Error fetching recipe type counts:", error);
                throw error;
            }

            const counts: Record<number, number> = {};
            for (const row of data) {
                if (row.recipe_type_id == null) continue;
                counts[row.recipe_type_id] = (counts[row.recipe_type_id] ?? 0) + 1;
            }
            return counts;
        }
    });
}
